import React from "react";
import AdminMerchant from "../components/AdminMerchant";
import useAdminMerchant from "../hooks/useAdminMerchant";

const AdminMerchantInterface = (props) => {
  const {
    typeShop,
    paymethod,
    email,
    name,
    showDeliverySchedule,
    logoType,
    fileLogo,
    fileBanner,
    fileHero,
    filePartnerLogo,
    address,
    currency,
    currencies,
    hasPagination,
    lang,
    langs,
    apikey,
    container,
    referer,
    submitting,
    locationPartner,
    shopPartner,
    editMode,
    tags,
    uitype,
    uiDisplayMode,
    categories,
    facebook,
    instagram,
    emailOwner,
    usershop,
    demo,
    partnerCategories,
    superUser,
    handlePostItem,
    onEmailChange,
    onNameChange,
    onShowDeliveryScheduleChange,
    onLogoTypeChange,
    onFileChange,
    onAddressChange,
    onLangChange,
    onRefererChange,
    onCurrencyChange,
    onPaginationChange,
    onContainerChange,
    onChangeTypeShop,
    onChangeUIType,
    onChangeUIDisplayMode,
    onChangePaymethod,
    onChangeLocationPartner,
    onChangeShopPartner,
    onTagsChange,
    onCategoriesChange,
    onChangeSocialInsta,
    onChangeSocialFB,
    onChangeUsershop,
    onEmailOwner,
    onChangeDemoSite,
  } = useAdminMerchant(props);
  return (
    <AdminMerchant
      superUser={superUser}
      typeShop={typeShop}
      paymethod={paymethod}
      email={email}
      name={name}
      showDeliverySchedule={showDeliverySchedule}
      logoType={logoType}
      fileLogo={fileLogo}
      fileBanner={fileBanner}
      fileHero={fileHero}
      filePartnerLogo={filePartnerLogo}
      address={address}
      currency={currency}
      currencies={currencies}
      hasPagination={hasPagination}
      lang={lang}
      langs={langs}
      apikey={apikey}
      container={container}
      referer={referer}
      submitting={submitting}
      locationPartner={locationPartner}
      shopPartner={shopPartner}
      editMode={editMode}
      tags={tags}
      uitype={uitype}
      uiDisplayMode={uiDisplayMode}
      categories={categories}
      instagram={instagram}
      facebook={facebook}
      emailOwner={emailOwner}
      usershop={usershop}
      demo={demo}
      partnerCategories={partnerCategories}
      handlePostItem={handlePostItem}
      onEmailChange={onEmailChange}
      onNameChange={onNameChange}
      onShowDeliveryScheduleChange={onShowDeliveryScheduleChange}
      onLogoTypeChange={onLogoTypeChange}
      onFileChange={onFileChange}
      onAddressChange={onAddressChange}
      onLangChange={onLangChange}
      onRefererChange={onRefererChange}
      onCurrencyChange={onCurrencyChange}
      onPaginationChange={onPaginationChange}
      onContainerChange={onContainerChange}
      onChangeTypeShop={onChangeTypeShop}
      onChangeUIType={onChangeUIType}
      onChangeUIDisplayMode={onChangeUIDisplayMode}
      onChangePaymethod={onChangePaymethod}
      onChangeLocationPartner={onChangeLocationPartner}
      onChangeShopPartner={onChangeShopPartner}
      onTagsChange={onTagsChange}
      onCategoriesChange={onCategoriesChange}
      onChangeSocialInsta={onChangeSocialInsta}
      onChangeSocialFB={onChangeSocialFB}
      onChangeUsershop={onChangeUsershop}
      onEmailOwner={onEmailOwner}
      onChangeDemoSite={onChangeDemoSite}
      onCancelAction={props.onCancelAction}
    />
  );
};

export default AdminMerchantInterface;
